import React from 'react';
import { Results } from '@components/SectionBlocks/Testshowcase/Results/Results';
import { TestResultBlock } from '@appTypes/testResultBlock';

interface TestResultSerializerProps {
  value: TestResultBlock;
}

export const Block: React.FC<TestResultSerializerProps> = ({ value }) => <Results block={value} />;
